import type { CambiarPasswordInput, CurrentUser, LoginInput } from '@app/shared';

import { api } from '../../../lib/api';

export const authApi = {
  async login(input: LoginInput): Promise<{ user: CurrentUser }> {
    const { data } = await api.post<{ user: CurrentUser }>('/auth/login', input);
    return data;
  },

  async logout(): Promise<void> {
    await api.post('/auth/logout');
  },

  async me(): Promise<{ user: CurrentUser }> {
    const { data } = await api.get<{ user: CurrentUser }>('/auth/me');
    return data;
  },

  async cambiarPassword(input: CambiarPasswordInput): Promise<void> {
    await api.post('/auth/cambiar-password', input);
  },
};
